import { render, staticRenderFns } from "./CheckPicture.vue?vue&type=template&id=09f63d8e&scoped=true&"
import script from "./CheckPicture.vue?vue&type=script&lang=js&"
export * from "./CheckPicture.vue?vue&type=script&lang=js&"
import style0 from "./CheckPicture.vue?vue&type=style&index=0&id=09f63d8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f63d8e",
  null
  
)

export default component.exports